export const carouselSliderSettings = {
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    centerMode: false,
    outerEdgeLimit: true,
    responsive: [
        {
            breakpoint: 1450,
            settings: {
                variableWidth: false,
                slidesToShow: 3.75,
                slidesToScroll: 3,
                arrows: true
            }
        },
        {
            breakpoint: 1390,
            settings: {
                variableWidth: false,
                slidesToShow: 3.5,
                slidesToScroll: 3,
                arrows: true
            }
        },
        {
            breakpoint: 1365,
            settings: {
                variableWidth: false,
                slidesToShow: 3.25,
                slidesToScroll: 3,
                arrows: true
            }
        },
        {
            breakpoint: 1188,
            settings: {
                variableWidth: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true
            }
        },
        {
            breakpoint: 1128,
            settings: {
                variableWidth: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: true
            }
        },
        {
            breakpoint: 1023,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
            }
        }
    ]
};
export const carouselSliderSettings = {
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    centerMode: false,
    outerEdgeLimit: true,
    responsive: [
        {
            breakpoint: 1450,
            settings: {
                variableWidth: false,
                slidesToShow: 3.75,
                slidesToScroll: 3,
                arrows: true
            }
        },
        {
            breakpoint: 1390,
            settings: {
                variableWidth: false,
                slidesToShow: 3.5,
                slidesToScroll: 3,
                arrows: true
            }
        },
        {
            breakpoint: 1365,
            settings: {
                variableWidth: false,
                slidesToShow: 3.25,
                slidesToScroll: 3,
                arrows: true
            }
        },
        {
            breakpoint: 1188,
            settings: {
                variableWidth: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true
            }
        },
        {
            breakpoint: 1128,
            settings: {
                variableWidth: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: true
            }
        },
        {
            breakpoint: 1023,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
            }
        }
    ]
};
